module.exports = __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.4b57c6a5.svg";